(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ShipmentDocumentDeleteModalController',ShipmentDocumentDeleteModalController);

    ShipmentDocumentDeleteModalController.$inject = ['$uibModalInstance','entity','ShipmentDocument'];

    function ShipmentDocumentDeleteModalController($uibModalInstance, entity, ShipmentDocument) {
        var vm = this;

        vm.shipmentDocument = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ShipmentDocument.delete({id:id}, function() {
                $uibModalInstance.close(true)
            });
        }
    }
})();
